module.exports = __webpack_public_path__ + "assets/img/free_8.8064bea6.png";